import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import util from '@tencent/vft-common/util';
import login from '@tencent/vft-common/login';
import cookie from '@tencent/vft-common/cookie';
import Boss from '@tencent/vft-common/Boss';
import env from '@tencent/vft-common/env';
import assign from 'lodash/assign';
var dm = location.host;
var url = location.pathname;
var pagetag = util.getUrlParam('ptag') || util.getUrlParam('PTAG') || util.getUrlParam('adtag') || util.getUrlParam('ADTAG') || '';
/*
 * 平台参数
 * iphone 7
 * aphone 8
 * ipad 9
 * h5 3000
 * web 1000
 * pc 2000
 */

export function getPlatform() {
  var plat = 3000;

  if (env.isIpad) {
    return 5;
  }

  if (env.isApp) {
    if (env.isAndroid) {
      plat = 8;
    } else if (env.isIphone) {
      plat = 7;
    } else if (env.isWin) {
      plat = 2000;
    }
  } else if (env.isMqq) {
    if (env.isAndroid) {
      plat = 8001;
    } else if (env.isIphone) {
      plat = 8002;
    }
  }

  return plat;
}
var pt = getPlatform();
/**
 * 配置BossId
 * @param PV 如{bossId: 3754, pwd: 598288292}
 * @param EVENT 如{bossId: 3753, pwd: 1449912345}
 */

var BossReport = /*#__PURE__*/function () {
  /**
   * 配置bossid信息和预设参数
   * @param pvBoss
   * @param eventBoss
   * @param presetParam
   */
  function BossReport(_ref) {
    var pvBoss = _ref.pvBoss,
        eventBoss = _ref.eventBoss,
        presetParam = _ref.presetParam;

    _classCallCheck(this, BossReport);

    if (pvBoss) {
      this.pvBoss = new Boss(pvBoss);
    }

    if (eventBoss) {
      this.eventBoss = new Boss(eventBoss);
    }

    this.presetParam = presetParam || this.getPresetParam;
  }

  _createClass(BossReport, [{
    key: "_getPresetParam",
    value: function () {
      var _getPresetParam2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof this.presetParam === 'function')) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this.presetParam();

              case 3:
                _context.t0 = _context.sent;
                _context.next = 7;
                break;

              case 6:
                _context.t0 = assign(BossReport.getPresetParam(), this.presetParam);

              case 7:
                return _context.abrupt("return", _context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getPresetParam() {
        return _getPresetParam2.apply(this, arguments);
      }

      return _getPresetParam;
    }()
  }, {
    key: "pv",
    value: function () {
      var _pv = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(param) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = assign;
                _context2.next = 3;
                return this._getPresetParam();

              case 3:
                _context2.t1 = _context2.sent;
                _context2.t2 = param;
                param = (0, _context2.t0)(_context2.t1, _context2.t2);
                param.f_type = 0;
                param.f_event = 'expose';

                try {
                  this.pvBoss.report(param);
                } catch (ex) {}

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function pv(_x) {
        return _pv.apply(this, arguments);
      }

      return pv;
    }()
  }, {
    key: "click",
    value: function () {
      var _click = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(param) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = assign;
                _context3.next = 3;
                return this._getPresetParam();

              case 3:
                _context3.t1 = _context3.sent;
                _context3.t2 = param;
                _context3.t3 = {
                  f_event: 'click'
                };
                param = (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t3);

                try {
                  this.eventBoss.report(param);
                } catch (ex) {}

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function click(_x2) {
        return _click.apply(this, arguments);
      }

      return click;
    }()
  }, {
    key: "expose",
    value: function () {
      var _expose = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(param) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.t0 = assign;
                _context4.next = 3;
                return this._getPresetParam();

              case 3:
                _context4.t1 = _context4.sent;
                _context4.t2 = param;
                _context4.t3 = {
                  f_event: 'expose'
                };
                param = (0, _context4.t0)(_context4.t1, _context4.t2, _context4.t3);

                try {
                  this.eventBoss.report(param);
                } catch (ex) {}

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function expose(_x3) {
        return _expose.apply(this, arguments);
      }

      return expose;
    }()
  }, {
    key: "module",
    value: function () {
      var _module = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(param) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = assign;
                _context5.next = 3;
                return this._getPresetParam();

              case 3:
                _context5.t1 = _context5.sent;
                _context5.t2 = param;
                param = (0, _context5.t0)(_context5.t1, _context5.t2);
                param.f_type = 1;
                param.f_event = 'expose';

                try {
                  this.eventBoss.report(param);
                } catch (ex) {}

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function module(_x4) {
        return _module.apply(this, arguments);
      }

      return module;
    }()
  }], [{
    key: "getPresetParam",
    value: function getPresetParam() {
      var presetParam = {
        f_url: url,
        f_dm: dm,
        f_url_param: '',
        f_pagetag: pagetag || '',
        f_logintype: '',
        f_uid: '',
        f_vuid: login.getVuid(),
        f_appid: '',
        f_pt: pt,
        _dc: Math.random()
      };

      if (login.isLogin()) {
        presetParam.f_logintype = cookie.get('main_login') || 'qq';

        if (presetParam.f_logintype === 'wx') {
          presetParam.f_uid = cookie.get('openid');
          presetParam.f_appid = cookie.get('appid');
        } else if (presetParam.f_logintype === 'qq') {
          presetParam.f_uid = login.getUid();

          if (login.isNewQQLogin()) {
            presetParam.f_appid = cookie.get('vqq_appid');
          }
        }
      } else {
        presetParam.f_logintype = '-';
      }

      if (location.href.split('?')[1]) {
        presetParam.f_url_param = decodeURIComponent(location.href.split('?')[1]).replace(/\$/g, '|||');
      }

      return presetParam;
    }
  }]);

  return BossReport;
}();

export { BossReport as default };